export default {"src":"/_next/static/media/qwiz-white.f28669a5.svg","height":243,"width":408};